const isPaytm = process.env.PAYTM === "true";
const build = isPaytm ? "paytm" : "es5";
module.exports = {
    isPaytm,
    build
};
